import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http-service.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { pncQueryParam, PncReport } from '../../model';


@Component({
  selector: 'pnc-report-list',
  templateUrl: './pnc-report-list.component.html',
  styleUrls: ['./pnc-report-list.component.scss']
})

export class PncReportListComponent implements OnInit {

  pncList: PncReport[] = [];
  totalItems: number = 0;
  loading: boolean = false;
  uploadModal: BsModalRef;
  pncQueryParam: pncQueryParam = new pncQueryParam();

  constructor(
    public httpClient: HttpClient,
    public httpService: HttpService,
    public modalService: BsModalService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.getPncReportList();
  }

  // getPncReportList() - Get list of all pnc report.
  getPncReportList(): void {
    this.loading = true;
    this.httpService.getPncReportList(this.pncQueryParam).subscribe((resp) => {
      if(resp.success){
        this.pncList = resp.result.items;
        this.totalItems = resp.result.totalItems;
        this.loading = false;
      }
    }, (error) => {
      if (error) {
        this.loading = false;
       // this.toastrService.error(error.message);
      }
    });
  }

  // sortPnc() - sort pnc list.
  sortPnc(fieldName:string): void {
    if(this.pncQueryParam.field === fieldName){
      if(this.pncQueryParam.order === 'ASC')
        this.pncQueryParam.order = 'DESC';
      else
        this.pncQueryParam.order = 'ASC';
    }else{
      this.pncQueryParam.field = fieldName;
      this.pncQueryParam.order = 'ASC';
    }
    this.getPncReportList();
  }

  // pageChanged() - Event is fired when page is changed
  pageChanged(event): void {
    this.pncQueryParam.page = event.page;
    this.getPncReportList();
  }

  // removePnc() - Remove ibis
  removePnc(pnc: PncReport): void {
    this.httpService.removePncItem(pnc.ID).subscribe((resp) => {
      if(resp.success){
        this.getPncReportList();
      }
    }, (error) => {
      if (error) {
       // this.toastrService.error(error.message);
      }
    });
  }

  /** Create Pnc Report */
  createPncReport(report: PncReport): void{
    if(report !== null)
      this.router.navigate(['/manage/research/pnc/detail/' + report.ID]);
    else this.router.navigate(['/manage/research/pnc/create']);
  }
}
